import React from 'react';
import { Link } from 'react-router-dom';

export default function History0409() {
  return (
    <main className="page">
      <div className="abstracts">
        <div className={`abstracts__container`}>
          <ul className="abstracts__top">
            <li>
              <Link to="/">Головна</Link>
            </li>
            <li>{'>'}</li>
            <li>
              <Link to="/abstracts">Конспекти</Link>
            </li>
            <li>{'>'}</li>
            <li>
              <Link to="/abstracts/history">Історія</Link>
            </li>
            <li>{'>'}</li>
            <li>
              <Link to="/abstracts/history/04-09">04.09</Link>
            </li>
          </ul>
          <h1>Архаїчна доба на теренах України, витоки укр культури</h1>
          <div className="abstracts__text">
            <p>Вчені такі періоди визначають існування людини:</p>
            <ol>
              <li>Кам'яний вік (мільйон років тому - 4 тисячоліття до н.е)</li>
              <li>Мідно-кам'яний (4 тис - 3 тис до н.е)</li>
              <li>Бронзовий вік (2-1 тис до н.е)</li>
              <li>Залізний вік (1 тис до н.е - 5 н.е)</li>
            </ol>
          </div>
          <h2>Кам'яний вік </h2>
          <div className="abstracts__text">
            <p>
              Жили люди - архантропи на Закарпатті 800 тис років - мільйон, клімат - субтропики,
              шаблезубі тигри, африканські савани, слони, носороги, леви …{' '}
            </p>
            <p>Марія Приймаченко - картини (левоподібні тварини) </p>
            <p>
              Нічого не створювали, тільки збирали, з'явилися перші знаряддя праці, колективи не
              були стабільні, жили недовго, чоловіки жили 30-32 роки, жінки 25-30 років. Поселення
              були знайдені на Закарпатті, королеве на Закарпатті - найдавніші поселення 1 млн років
              тому, знайдені рубили, скребки, метальний камінь …{' '}
            </p>
            <p>
              Потім настає похолодання, змінюється клімат, панує тундра, тому інші тварини -
              мамонти, волохаті носороги, північні олені, новий тип людини - неандертальці
              (палеонтропи) були просунені люди, багато чого вже вміли - вогонь використовували, не
              тільки для обігріву і жарки, а й для обробки матеріалів, робили одяг із кісток і шкір
              мамонтів, робили житла, гостроконечники, полювання було головним заняттям ще на дикого
              коня (зубра), в Криму були антилопи, осли, коні, жінки і діти теж збиральництвом
              займались
            </p>
            <p>
              100 тисяч років тому виникають суспільні відносини, структурується людська спільнота,
              виникає поняття “рід”, поняття родової честі, був матріархат
            </p>
            <p>
              Пізній палеоліт 35-40 тис років тому - людина сучасного типу - неоантроп
              (кроманьйонець) близько 500 стоянок в Україні - незначні, 4-5 жител, ями для сміття,
              зерна, господарство, зростає майстерність - виготовлення виробів, серпи кращої якості,
              сребки, ножі із кременю, на Харкові є майстерні з кремнем, туди приходили пішки люди
              здалеку, виготовляли тут. 11-10 тис років тому в Європі встановлюються близький до суч
              клімат, колишні тундри в ліси
            </p>
            <p>
              10-8 тис років тому - період мезоліту, лук і стріли, приручений собака наприклад для
              захисту, були тонкі вироби - з лози робили вершу (щоб ловити рибу)
            </p>
            <p>
              8 тис років тому - племена вступають у неоліт (нео - новий), неолітична революція -
              перша технічна революція - переворот по всіх сферах, змінився менталітет, перехід від
              привласнюючого способу виробництва до відтворювального, люди думають про майбутнє,
              відбулась моральна революція, чіткими стають - табу (не зародок моралі, лише
              соціальний регулятив, але передумова виникнення моралі), проміскуїтет - невпорядковані
              статеві акти із багатьма партнерами, починають садити пшеницю, овес із Близького
              Сходу, винайдення кераміки для посуду (глина після оброблення вогнем)
            </p>
          </div>
          <h2>Мідно-кам'яний вік (енеоліт)</h2>
          <div className="abstracts__text">
            <p>
              4-3 тис до н.е, винахід мідді - революція, бо тоді сокира легше, гостріше,
              використовують тягливу силу бика, приручений тур, розвивається швидко у районах
              Прикарпаття та Дніпра, гончарство, землеобробка, металообробка, культура Трипілля
              (назва від села Трипілля), є музей у Легедзино, знайшов Трипілля у 1897 - Вікентій
              Хвойко сказав, що трипільці предки українців, раніше знайшов Теодор Бурада 1884 біля
              Румунського селища Кукутень, також Салтівсько-Маяцька культура. Вони не були
              профессіоналами, як археологи, але “новачкам везе”. Трипілля стало сенсацією через
              шумерів, Юрій Шилов написав книги, де доводиться, що шумери прийшли з України,
              будували протоміста, принцип - полюс великий в центрі, а навколо менші поселення, вони
              не довго фіксуються на одному місці - 50 років проходить, вони спалюються і знову
              будують з нуля через екстенсивне землеробство (земля виснажувалась) - кочів’я, люди
              схожі на вірмен, низькорослі, мова - іраномовні, вони були миролюбиві, тобто поселення
              відкриті, без укриттів, з'являються надлишки їжі, тому є можливість утримання воїнів,
              знали кераміку, але їх посуд був дивним, бо гладенький ззовні і негладкий всередині -
              ліплена кераміка, вона міцна, з візерунками, орнаментика мала символічне значення,
              сенс - треба було захисти те, що всередині, подбати, щоб рідина завжди була (апотропей
              - предмети або зображення, яким у давніх культурах приписували магічні властивості
              відлякувати злих духів, нечисту силу, демонів від людей, осель, свійської худоби),
              вчені вважають, що українці не могли не успадкувати трипільські традиції, існує
              загадки, куди ж ділись трипільці і як з'явилися (можливо автохтони - ті, хто вже жили
              там, а можливо і пришли після міграції), вони зникають; можливі причини - засуха
              (господарству - кінець), нашестя арійців (кочовиків), в Україні знайшлись найраніші їх
              поселення мова - санскрит, є версія, що трипільці + арійці, тому поховання мали ознаки
              і від трипільців, і від арійців. Вважали, що був матріархат, бо було знайдено багато
              статуеток жіночих, лише 3 із 500 - чоловічі, культ Великої Матері, а інші не згодні.
              Неолітичні венери - жінка з гарними грудами і стегнами, а голови немає, трапляються
              фігурки з головою, однак без промальованого обличчя.
            </p>
            <p>Приходять кочові народи, наприклад кіммерійці, скіфи, половці (пізніше)</p>
          </div>
        </div>
      </div>
    </main>
  );
}
